import { LatLngBounds } from 'leaflet';
import { useCallback } from 'react';
import ApiSupplier from '../../../../api/api-supplier';
import { CountryInfo } from '../../../../api/model';
import Constants from '../../../../constants';
import { SideDrawerMode } from '../../../../store/SideDrawer/model';
import SatelliteArchive from '../OrderWorkflow/satellite-archive';
import { SKYMAP50_ARCHIVE_COLLECTION_TERMS } from '../OrderWorkflow/satellite-order-conditions';
import { Industry } from '../OrderWorkflow/satellite-order-user-details';

const Skymap50Archive = () => {
    return (
        <SatelliteArchive
            title="ARCHIVAL"
            analyticsCategory="Satellite - SKYM50 - Archival 50cm"
            logoUrl="/assets/floating-drawer-satellite-icons/satellite-skymap50-logo.png"
            validAOIParameters={Constants.SKYMAP50_PARAMETERS.ARCHIVAL}
            rootSideDrawerMode={SideDrawerMode.SATELLITE_SKYMAP50}
            termsAndConditionsChecklist={SKYMAP50_ARCHIVE_COLLECTION_TERMS}
            termsAndConditionsHref="/skymap50-terms"
            isVoucherVisible={true}
            fetchSearchResults={useCallback((aoi: LatLngBounds) => {
                return ApiSupplier.searchArchive(aoi, 'SKYM50', 'A50');
            }, [])}
            fetchPrice={(aoi: LatLngBounds, sceneIds: string[], voucher?: string, countryCode?: string) => {
                return ApiSupplier.calculateArchivePrice(aoi, sceneIds, 'SKYM50', 'A50', voucher, countryCode);
            }}
            createOrder={(
                selectedAOI: LatLngBounds,
                sceneIds: string[],
                stripeToken: any, // eslint-disable-line @typescript-eslint/no-explicit-any
                userCompanyName: string,
                userIndustry: Industry,
                userCountryInfo: CountryInfo,
                voucher: string | undefined
            ) => {
                return ApiSupplier.createOrder(
                    selectedAOI,
                    sceneIds,
                    'SKYM50',
                    'A50',
                    stripeToken,
                    userCompanyName,
                    userIndustry,
                    userCountryInfo,
                    voucher
                );
            }}
        />
    );
};

export default Skymap50Archive;
